import { useEffect, useRef } from "react";
import type { UseFormSetValue, FieldValues } from "react-hook-form";
import { useCompaniesStore, useDisableCRUD } from "../../../store/admin/companiesStore";

/**
 * Limpia equipos al cambiar compañía y expone si el formulario debe bloquearse
 * (reseller sin compañía seleccionada).
 */
export function useReportCompanyScope<T extends FieldValues & { devices: string[] }>(
  setValue: UseFormSetValue<T>,
  onCompanyChange?: () => void,
) {
  const companyId = useCompaniesStore((s) => s.companyId);
  const disableWithoutCompany = useDisableCRUD();
  const onCompanyChangeRef = useRef(onCompanyChange);
  onCompanyChangeRef.current = onCompanyChange;

  useEffect(() => {
    setValue("devices" as any, [] as any);
    onCompanyChangeRef.current?.();
  }, [companyId, setValue]);

  return { companyId, disableWithoutCompany };
}
